import React from 'react'
import './Realtors.scss'
import realtor1 from '../../img/realtor-1.jpeg'
import realtor2 from '../../img/realtor-2.jpeg'
import realtor3 from '../../img/realtor-3.jpeg'

export const Realtors = () => {
    return (
        <div className="realtors">
                <h3 className="heading-3">Top 3 mäklare</h3>
                <div className="realtors__list">
                    <img src={realtor1} alt="Realtor 1" className="realtors__img"></img>
                    <div className="realtors__details">
                        <h4 className="heading-4 heading-4--light">Erik Edman</h4>
                        <p className=" realtors__sold">200 sålda hus</p>
                    </div>

                    <img src={realtor2} alt="Realtor 2" className="realtors__img"></img>
                    <div className="realtors__details">
                        <h4 className="heading-4 heading-4--light">Jenny Niels</h4>
                        <p className=" realtors__sold">135 sålda hus</p>
                    </div>

                    <img src={realtor3} alt="Realtor 3" className="realtors__img"></img>
                    <div className="realtors__details">
                        <h4 className="heading-4 heading-4--light">Tobias Jeglertz</h4>
                        <p className=" realtors__sold">88 sålda hus</p>
                    </div>
                </div>
        </div>
    )
}
